module.exports = __webpack_public_path__ + "static/media/bg_purple.089a631a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_purple.png
// module id = 659
// module chunks = 0